import { render, staticRenderFns } from "./BookingTableFrDg.vue?vue&type=template&id=1ec75c3b"
import script from "./BookingTableFrDg.vue?vue&type=script&lang=js"
export * from "./BookingTableFrDg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec75c3b')) {
      api.createRecord('1ec75c3b', component.options)
    } else {
      api.reload('1ec75c3b', component.options)
    }
    module.hot.accept("./BookingTableFrDg.vue?vue&type=template&id=1ec75c3b", function () {
      api.rerender('1ec75c3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/BookingTableFrDg.vue"
export default component.exports